export const CATEGORYLIST = "CATEGORYLIST"
export const CATEGORYADD = "CATEGORYADD"
export const CATEGORYSTATUS = "CATEGORYSTATUS"
export const CATEGORYDELETE = "CATEGORYDELETE"
export const CATEGORYUPDATE  = "CATEGORYUPDATE"
export const CATEGORYDETAILS = "CATEGORYDETAILS"


